@if (column(); as column) {
  @switch (rowType()) {
    @case ('text') {
      <lepi-text-cell [column]="column" [row]="row()" />
    }
    @case ('badge') {
      <lepi-badge-cell [column]="column" [row]="row()" />
    }
    @case ('checkbox') {
      <lepi-checkbox-cell [column]="column" [row]="row()" [(selecteds)]="selecteds" />
    }
    @case ('custom') {
      <lepi-custom-cell [column]="column" [row]="row()" />
    }
    @case ('drag-handler') {
      <lepi-drag-handler-cell [column]="column" [row]="row()" />
    }
  }
}
